<!--
 * @Description: 登录
 * @Author: huangshiwen
 * @Date: 2022-05-30 13:40:58
 * @LastEditTime: 2022-06-06 17:07:43
-->
<template>
    <Common>
      <template slot="cd">
          <CdhospitalBookTab />
      </template>
      <template slot="sz">
          <SzhospitalBookTab />
      </template>
      <template slot="hf">
          <CdhospitalBookTab />
      </template>
    </Common>
</template>

<script>
import CdhospitalBookTab from "@/components/hospitalBookTab/cdhospitalBookTab"
import SzhospitalBookTab from "@/components/hospitalBookTab/szhospitalBookTab"
export default{
  components:{
    CdhospitalBookTab,
    SzhospitalBookTab
  },
  
  data(){
    return {

    }
  },
  created(){

  }
}
</script>
<style lang="less" scoped>

</style>